/* globals */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import ActivationPage from '../components/Activation/ActivationPage';
import { activate } from '../actions/api/apis';

class ActivationContainer extends Component {
  constructor(props) {
    super(props);
    const { dispatch } = props;
    if (dispatch) {
      dispatch({ type: 'STOP_API_CALL_TIMER' });
    }
  }

  render() {
    const {
      dispatch,
      apiToken,
      isLogin,
      activationCode,
      formatError,
      errorCode,
      hasError,
      activated,
    } = this.props;
    const redirectTo = (!isLogin && '/ds/login') || (activated && '/ds/') || '';
    return (
      (redirectTo && <Redirect to={redirectTo} />) || (
        <ActivationPage
          checkActivationCode={() =>
            dispatch({ type: 'CHECK_UUID', caller: 'update' })
          }
          onClickActivate={() => dispatch(activate(apiToken, activationCode))}
          onChangeInput={param =>
            dispatch({ type: 'CHECK_UUID', param, caller: 'input' })
          }
          formatError={formatError}
          hasError={hasError}
          activationCode={activationCode}
          errorCode={errorCode}
        />
      )
    );
  }
}

ActivationContainer.propTypes = {
  dispatch: PropTypes.func.isRequired,
  isLogin: PropTypes.bool.isRequired,
  apiToken: PropTypes.string.isRequired,
  activated: PropTypes.bool.isRequired,
  activationCode: PropTypes.string.isRequired,
  formatError: PropTypes.bool.isRequired,
  errorCode: PropTypes.string.isRequired,
  hasError: PropTypes.bool.isRequired,
};

const mapStateToProps = state => ({
  isLogin: state.main.isLogin,
  apiToken: state.main.apiToken,
  activated: state.activation.activated,
  activationCode: state.activation.activationCode,
  formatError: state.activation.formatError,
  errorCode: state.activation.errorCode,
  hasError: state.activation.hasError,
});

export default connect(mapStateToProps)(ActivationContainer);
